import { render, staticRenderFns } from "./shopOverview.vue?vue&type=template&id=079c8f90&scoped=true"
import script from "./shopOverview.vue?vue&type=script&lang=js"
export * from "./shopOverview.vue?vue&type=script&lang=js"
import style0 from "./shopOverview.vue?vue&type=style&index=0&id=079c8f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c8f90",
  null
  
)

export default component.exports